import { ObjectRepository, usePersistedObject } from '@framework/repository';
import { GroupSetting } from '@group/domain/GroupEntity/GroupSetting';
import { RTDBPath, type WorkspaceId } from 'balus-common';
import { useEffect, useState } from 'react';
import { Workspace } from './workspace';

export function useViewModelIndividualPermissionEnabled(workspaceId: WorkspaceId): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  const [workspace] = usePersistedObject(Workspace, RTDBPath.Workspace.workspaceEntityPath(workspaceId));

  useEffect(() => {
    if (!workspace) return;

    const repo = new ObjectRepository(GroupSetting, RTDBPath.Group.settingPath(workspace.groupId));

    repo.addListener((groupSetting) => {
      setEnabled(
        (groupSetting?.enableIndividualViewModelPermissions &&
          workspace.setting.enableIndividualViewModelPermissions) ||
          false
      );
    });
    return () => repo.removeListener();
  }, [workspace]);

  return enabled;
}
